import { Badge } from "react-bootstrap";
import { CommonButton, CommonInput, CommonSelect } from "../../Input";
import DataTable from "../../table/DataTable";

const HistoryTab = ({
  historyData,
  historyFilters,
  setHistoryFilters,
  onSearch,
  onReset,
  onViewDetails,
}) => {
  return (
    <div className="history-tab">
      <div className="row g-2 align-items-end mb-4">
        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
          <CommonInput
            placeholder="Enter ID"
            value={historyFilters.id}
            onChange={(e) =>
              setHistoryFilters({ ...historyFilters, id: e.target.value })
            }
          />
        </div>
        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
          <CommonSelect
            placeholder="Select payment method"
            options={[
              { value: "Cash", label: "Cash" },
              { value: "Bank Transfer", label: "Bank Transfer" },
            ]}
            value={historyFilters.method}
            onChange={(val) =>
              setHistoryFilters({ ...historyFilters, method: val })
            }
          />
        </div>
        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
          <CommonSelect
            placeholder="Select status"
            options={[
              { value: "Approved", label: "Approved" },
              { value: "Pending", label: "Pending" },
              {
                value: "Waiting for approval",
                label: "Waiting for approval",
              },
            ]}
            value={historyFilters.status}
            onChange={(val) =>
              setHistoryFilters({ ...historyFilters, status: val })
            }
          />
        </div>
        <div className="col-xl-3 col-lg-3 col-md-12 col-sm-6 text-end">
          <div className="d-flex gap-2">
            <CommonButton
              variant="outline"
              className="p-0 d-flex align-items-center justify-content-center"
              onClick={onReset}
            >
              <i className="flaticon-381-repeat-1"></i>
            </CommonButton>
            <CommonButton
              className="p-0 d-flex align-items-center justify-content-center"
              onClick={onSearch}
            >
              <i className="fa fa-search fs-14"></i>
            </CommonButton>
          </div>
        </div>
      </div>
      <DataTable
        columns={[
          { label: "ID", key: "id" },
          {
            label: "Date & Time",
            key: "dateTime",
            cellStyle: () => ({ whiteSpace: "pre-line" }),
          },
          {
            label: "Sender Name",
            key: "sender",
            render: (item) => (
              <div>
                <div className="fw-bold">{item.senderName}</div>
                <small className="text-muted">{item.senderEmail}</small>
              </div>
            ),
          },
          { label: "Receiver Name", key: "receiverName" },
          { label: "Payment Method", key: "paymentMethod" },
          { label: "Send Amount", key: "sendAmount" },
          {
            label: "Status",
            key: "status",
            render: (item) => (
              <Badge
                style={{
                  color: "#ffffff",
                  borderRadius: "6px",
                  backgroundColor:
                    item.status === "Approved" ? "#28C76F" : "#FF9F43",
                  padding: "6px 10px",
                }}
              >
                {item.status}
              </Badge>
            ),
          },
          {
            label: "Actions",
            key: "actions",
            render: (item) => (
              <button
                className="btn btn-link p-0"
                onClick={() => onViewDetails(item)}
              >
                <i className="far fa-eye text-dark fs-16"></i>
              </button>
            ),
          },
        ]}
        data={historyData}
      />
    </div>
  );
};

export default HistoryTab;
